export const columnHeader = [
	{
		key: 'lid', name: 'Node', type: 'text', system: false, filter: false
	},
	{
		key: 'subnet', name: 'Subnet', type: 'text', system: false, filter: true
	},
	{
		key: 'ip', name: 'IP', type: 'text', system: false, filter: true
	},
	{
		key: 'type', name: 'Type', type: 'list', system: false, filter: true
	},
	{
		key: 'online', name: 'Online', type: 'list', system: false, filter: true
	},
	{
		key: 'use_cases', name: 'Use Cases', type: 'multiple-list', system: true, filter: true
	},
	{
		key: 'websites', name: 'Websites', type: 'multiple-list', system: true, filter: true
	},
	{
		key: 'tags', name: 'Tags', type: 'multiple-list', system: true, filter: true
	},
	{
		key: 'geo_maxmind', name: 'MaxMind', type: 'text', system: false, filter: true
	},
	{
		key: 'users', name: 'Users', type: 'text', system: true, filter: false
	},
	{
		key: 'options', name: '', type: 'text', system: true, filter: false
	}
];

export const useCases = [
	{
		"slug": "rank_tracking",
		"name": "Rank Tracking"
	},
	{
		"slug": "sales_intelligence",
		"name": "Sales Intelligence"
	},
	{
		"slug": "social_media_scrapping",
		"name": "Social Media Scrapping"
	},
	{
		"slug": "web_scrapping",
		"name": "Web Scrapping"
	}
]

export const tags = [
	{
		"id": 1,
		"name": "Tag 1",
		"mobile": 1,
		"url": "http://tag1.com",
		"info": "Tag 1 Info"
	},
	{
		"id": 2,
		"name": "Tag 2",
		"mobile": 1,
		"url": "http://tag2.com",
		"info": "Tag 2 Info"
	},
	{
		"id": 3,
		"name": "Tag 3",
		"mobile": 0,
		"url": "http://tag3.com",
		"info": "Tag 3 Info"
	},
	{
		"id": 4,
		"name": "Tag 4",
		"mobile": 1,
		"url": "http://tag4.com",
		"info": "Tag 4 Info"
	}
];

export const types = [
	{ value: "Private", label: "Private" },
	{ value: "Premium", label: "Premium" }
];

export const statuses = [
	{ value: "yes", label: "Yes" },
	{ value: "no", label: "No" }
]